import { useSelector } from 'react-redux';
import { useFinancialPlanQuery } from '../../../../../api/useFinancialPlanQuery';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { selectEstatePlanningGoal } from '../Checklist/Checklist.selectors';
import type {
  EssentialRolePredefinedOptionDTO,
  EssentialTeamRoleDTO,
} from '../../../../../types/goalsDTO';

interface UseEssentialRolesParams {
  isPrint: boolean;
}

export const useEssentialRoles = ({ isPrint }: UseEssentialRolesParams) => {
  const { clientId, goalId } = useRouteParams();

  const queryResult = useFinancialPlanQuery();

  const legacyGoal = useSelector(state => isPrint && selectEstatePlanningGoal(state));

  if ((!isPrint && !queryResult.data) || (isPrint && !legacyGoal)) {
    return null;
  }

  const goal = isPrint
      ? legacyGoal
      : queryResult.data?.Goals.find(_goal => _goal.GoalId === goalId);

  if (!goal) {
    return null;
  }

  return {
    roles: goal.EssentialTeamRoles ?? [],
    predefinedOptions: goal.EssentialRolePredefinedOptions ?? [],
    clientId,
    goal,
  };
};
